import { FormattedMessage } from 'react-intl';

import { useTypedParams } from '@sorare/routing';

import { Position } from '@sorare/core/src/__generated__/globalTypes';

import CollectionCardsPage from '@sorare/gameplay/src/components/collections/CardsPage';

import { PageParams } from './__generated__/routeParams';

const groupBy = [
  {
    id: 'pitchers',
    label: (
      <FormattedMessage id="slot.pitchers.name" defaultMessage="Pitchers" />
    ),
    positions: [
      Position.baseball_starting_pitcher,
      Position.baseball_relief_pitcher,
    ],
  },
  {
    id: 'catchersAndInfielders',
    label: (
      <FormattedMessage
        id="slot.catchersAndInfielders.name"
        defaultMessage="Catchers & Infielders"
      />
    ),
    positions: [
      Position.baseball_catcher,
      Position.baseball_designated_hitter,
      Position.baseball_first_base,
      Position.baseball_second_base,
      Position.baseball_third_base,
      Position.baseball_shortstop,
    ],
  },
  {
    id: 'outfielders',
    label: (
      <FormattedMessage
        id="slot.outfielders.name"
        defaultMessage="Outfielders"
      />
    ),
    positions: [Position.baseball_outfield],
  },
];

const CardsPage = () => {
  const { slug, collectionSlug } = useTypedParams<PageParams>();

  if (!slug || !collectionSlug) {
    return null;
  }

  return (
    <CollectionCardsPage
      slug={slug}
      collection={collectionSlug}
      groupBy={groupBy}
    />
  );
};
export default CardsPage;
